<div class="status-container" [ngClass]="rootClassName">
  @if (isWeb) {
    <div tourAnchor="anchor.status.today" class="status-container-tile">
      <pop-ui-home-status-tile [state]="today"></pop-ui-home-status-tile>
    </div>
    <div tourAnchor="anchor.status.overall" class="status-container-tile">
      <pop-ui-home-status-tile [state]="overall"></pop-ui-home-status-tile>
    </div>
  } @else {
    <div tourAnchor='anchor.status.today' class="status-container-tile">
      <pop-ui-home-status-tile [(state)]="state"></pop-ui-home-status-tile>
    </div>
  }
</div>
<div class="frame24pxspacer"></div>
